import { clsx } from 'clsx';

import Icon from '~/src/common/components/Icon/Icon';
import Link from '~/src/common/components/Link/Link';
import { useFeatureFlag } from '~/src/common/services/FeatureFlag/client';
import I18n from '~/src/common/services/I18n';
import Tracker from '~/src/common/services/Tracker';
import { ProductDetailed } from '~/src/common/typings/product';

import styles from './ProductShortDescription.module.scss';

interface Props {
  className?: string;
  product: ProductDetailed;
}

const ProductShortDescription = (props: Props) => {
  const isXSellVisible = useFeatureFlag('configuration-page-produit') === 'with-xsell';

  if (props.product.shortDescription == null) return null;

  return (
    <div className={clsx(styles.container, props.className)}>
      <div>{props.product.shortDescription}</div>

      {isXSellVisible && (
        <Link
          className={styles.linkDetails}
          href="#product-information"
          onClick={e => {
            // On veut eviter l'update de l'url si possible
            const element = document.querySelector('#product-information');
            if (element) {
              e.preventDefault();
              element.scrollIntoView(true);
            }

            Tracker.sendEvent('click product details', {
              'product id': props.product.id,
              'product name': props.product.name,
            });
          }}>
          <span>{I18n.t('view-product-screen.view-details')}</span>
          <Icon name="arrow-down" size={24} color="ACTION_DEFAULT" />
        </Link>
      )}
    </div>
  );
};

export default ProductShortDescription;
